import { Model } from "../../model";
import { ILatLng } from "@ionic-native/google-maps";

export class Field implements Model {
    _id: string;
    code: string;
    description: string;
    area: number;
    varietyId: string;
    sectorId: string;
    productionPeriodId: string;
    polygon: ILatLng[];

    constructor(obj: any) {
        this._id = obj._id;
        this.code = obj.code;
        this.description = obj.description;
        this.area = obj.area;
        this.varietyId = obj.varietyId;
        this.sectorId = obj.sectorId;
        this.productionPeriodId = obj.productionPeriodId;
        this.polygon = obj.polygon;
    };

    getFieldKey() {
        return this.code + '-' + this.sectorId;
    }
}